export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';
export const RESET_REGISTER_USER = 'RESET_REGISTER_USER';

export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';

export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_ERROR_CLEAR = 'LOGIN_USER_ERROR_CLEAR';
export const LOGIN_USER_CLEAR = 'LOGIN_USER_CLEAR';

export const LOGIN_ADMIN_REQUEST = 'LOGIN_ADMIN_REQUEST';
export const LOGIN_ADMIN_SUCCESS = 'LOGIN_ADMIN_SUCCESS';
export const LOGIN_ADMIN_FAILURE = 'LOGIN_ADMIN_FAILURE';
export const LOGIN_ADMIN_CLEAR = 'LOGIN_ADMIN_CLEAR';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const GET_JOB_REQUEST = 'GET_JOB_REQUEST';
export const GET_JOB_SUCCESS = 'GET_JOB_SUCCESS';
export const GET_JOB_FAILURE = 'GET_JOB_FAILURE';
export const RESET_JOBS = 'RESET_JOBS';

export const GET_JOB_REQUEST_INIT = 'GET_JOB_REQUEST_INIT';
export const GET_JOB_REQUEST_BY_ID = 'GET_JOB_REQUEST_BY_ID';
export const GET_JOB_SUCCESS_BY_ID = 'GET_JOB_SUCCESS_BY_ID';
export const GET_JOB_FAILURE_BY_ID = 'GET_JOB_FAILURE_BY_ID';
export const CLEAR_JOB_DETAILS = 'CLEAR_JOB_DETAILS';
export const GET_ROUTE_COUNT_REQUEST = 'GET_ROUTE_COUNT_REQUEST';
export const GET_ROUTE_COUNT_SUCCESS = 'GET_ROUTE_COUNT_SUCCESS';
export const RESET_ROUTE_COUNT = 'RESET_ROUTE_COUNT';

export const SET_JOB_PROPOSAL = 'SET_JOB_PROPOSAL';

export const ADD_JOB_PROPOSAL_REQUEST = 'ADD_JOB_PROPOSAL_REQUEST';
export const ADD_JOB_PROPOSAL_SUCCESS = 'ADD_JOB_PROPOSAL_SUCCESS';
export const ADD_JOB_PROPOSAL_FAILURE = 'ADD_JOB_PROPOSAL_FAILURE';
export const GET_PROPOSAL_BY_JOB_REQUEST = 'GET_PROPOSAL_BY_JOB_REQUEST';
export const GET_PROPOSAL_BY_JOB_SUCCESS = 'GET_PROPOSAL_BY_JOB_SUCCESS';
export const GET_PROPOSAL_CLIENTINFO_BY_JOBPOST_REQUEST =
  'GET_PROPOSAL_CLIENTINFO_BY_JOBPOST_REQUEST';

export const GET_PROPOSAL_LIST_BY_JOB_SUCCESS = 'GET_PROPOSAL_LIST_BY_JOB_SUCCESS';
export const GET_PROPOSAL_LIST_BY_JOB_FAILURE = 'GET_PROPOSAL_LIST_BY_JOB_FAILURE';
export const GET_PROPOSAL_LIST_BY_JOB_REQUEST = 'GET_PROPOSAL_LIST_BY_JOB_REQUEST';

export const CONTRACT_INIT = 'CONTRACT_INIT';
export const GET_CONTRACT_REQUEST = 'GET_CONTRACT_REQUEST';
export const GET_CONTRACT_REQUEST_FOR_CLIENT_DATA = 'GET_CONTRACT_REQUEST_FOR_CLIENT_DATA';
export const GET_CONTRACT_REQUEST_FOR_CLIENT_DASH = 'GET_CONTRACT_REQUEST_FOR_CLIENT_DASH';
export const RESET_CONTRACT_REQUEST = 'RESET_CONTRACT_REQUEST';
export const GET_CONTRACT_SUCCESS = 'GET_CONTRACT_SUCCESS';
export const GET_CONTRACT_FAILURE = 'GET_CONTRACT_FAILURE';

export const GET_CONTRACT_BY_JOB_ID_SUCCESS = 'GET_CONTRACT_BY_JOB_ID_SUCCESS';
export const GET_CONTRACT_BY_JOB_ID_FAILURE = 'GET_CONTRACT_BY_JOB_ID_FAILURE';
export const GET_CONTRACT_BY_JOB_ID_REQUEST = 'GET_CONTRACT_BY_JOB_ID_REQUEST';

export const PROPOSAL_CLIENTINFO_BY_JOBPOST_INIT = 'PROPOSAL_CLIENTINFO_BY_JOBPOST_INIT';
export const RESET_JOB_PROPOSAL = 'RESET_JOB_PROPOSAL';
export const RESET_JOB_PROPOSAL_ERROR = 'RESET_JOB_PROPOSAL_ERROR';
export const GET_INVITEDCODER_REQUEST = 'GET_INVITEDCODER_REQUEST';
export const PATCH_INVITEDCODER_REQUEST = 'PATCH_INVITEDCODER_REQUEST';
export const GET_RECOMMENDEDCODER_FAILURE = 'GET_RECOMMENDEDCODER_FAILURE';
export const GET_INVITEDCODER_SUCCESS = 'GET_INVITEDCODER_SUCCESS';
export const GET_INVITEDCODER_FAILURE = 'GET_INVITEDCODER_FAILURE';
export const GET_RECOMMENDEDCODER_SUCCESS = 'GET_RECOMMENDEDCODER_SUCCESS';
export const GET_RECOMMENDEDCODER_REQUEST = 'GET_RECOMMENDEDCODER_REQUEST';

export const SUBMIT_FIXED_PROPOSAL_REQUEST = 'SUBMIT_FIXED_PROPOSAL_REQUEST';
export const SUBMIT_FIXED_PROPOSAL_SUCCESS = 'SUBMIT_FIXED_PROPOSAL_SUCCESS';
export const SUBMIT_FIXED_PROPOSAL_FAILURE = 'SUBMIT_FIXED_PROPOSAL_FAILURE';
export const PATCH_PROPOSAL_REQUEST = 'PATCH_PROPOSAL_REQUEST';

export const PUT_PROPOSAL_REQUEST = 'PUT_PROPOSAL_REQUEST';
export const PUT_PROPOSAL_SUCCESS = 'PUT_PROPOSAL_SUCCESS';
export const PUT_PROPOSAL_FAILURE = 'PUT_PROPOSAL_FAILURE';

export const GET_PROPOSAL_REQUEST = 'GET_PROPOSAL_REQUEST';
export const GET_PROPOSAL_BY_FILTER_REQUEST = 'GET_PROPOSAL_BY_FILTER_REQUEST';
export const GET_PROPOSAL_SUCCESS = 'GET_PROPOSAL_SUCCESS';

export const SET_JOB_FAVOURITE = 'SET_JOB_FAVOURITE';

export const GET_ALL_TECHNOLOGY = 'GET_ALL_TECHNOLOGY';
export const SET_ALL_TECHNOLOGY = 'SET_ALL_TECHNOLOGY';
export const GET_ALL_TECHNOLOGY_FAILURE = 'GET_ALL_TECHNOLOGY_FAILURE';
export const CREATE_JOB_POST = 'CREATE_JOB_POST';
export const JOB_CREATED_SUCCESSFULLY = 'JOB_CREATED_SUCCESSFULLY';
export const JOB_CREATION_ERROR = 'JOB_CREATION_ERROR';
export const CLEAR_JOB_CREATION = 'CLEAR_JOB_CREATION';
export const UPDATE_JOB_POST_REQUEST = 'UPDATE_JOB_POST_REQUEST';
export const UPDATE_JOB_POST_SUCCESS = 'UPDATE_JOB_POST_SUCCESS';
export const GET_CLIENTINFO_BY_JOBPOST = 'GET_CLIENTINFO_BY_JOBPOST';
export const GET_CLIENTINFO_BY_JOBPOST_REQUEST = 'GET_CLIENTINFO_BY_JOBPOST_REQUEST';

export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZNOE_SUCCESS';
export const GET_TIMEZONE_FAILURE = 'GET_TIMEZONE_FAILURE';

export const POST_TIMESHEET_REQUEST = 'POST_TIMESHEET_REQUEST';
export const POST_TIMESHEET_SUCCESS = 'POST_TIMESHEET_SUCCESS';
export const POST_TIMESHEET_FAILURE = 'POST_TIMESHEET_FAILURE';
export const RESET_TIMESHEET_RESET = 'RESET_TIMESHEET_RESET';
export const TIMESHEET_INIT = 'TIMESHEET_INIT';
export const GET_TIMESHEET_REQUEST = 'GET_TIMESHEET_REQUEST';
export const GET_TIMESHEET_SUCCESS = 'GET_TIMESHEET_SUCCESS';
export const GET_TIMESHEET_FAILURE = 'GET_TIMESHEET_FAILURE';
export const PATCH_TIMESHEET_REQUEST = 'PATCH_TIMESHEET_REQUEST';
export const PATCH_TIMESHEET_SUCCESS = 'PATCH_TIMESHEET_SUCCESS';
export const PATCH_TIMESHEET_FAILURE = 'PATCH_TIMESHEET_FAILURE';
export const PUT_TIMESHEET_REQUEST = 'PUT_TIMESHEET_REQUEST';
export const PUT_TIMESHEET_SUCCESS = 'PUT_TIMESHEET_SUCCESS';
export const PUT_TIMESHEET_FAILURE = 'PUT_TIMESHEET_FAILURE';

export const GET_MILESTONE_REQUEST = 'GET_MILESTONE_REQUEST';
export const GET_MILESTONE_SUCCESS = 'GET_MILESTONE_SUCCESS';
export const GET_MILESTONE_FAILURE = 'GET_MILESTONE_FAILURE';
export const POST_MILESTONE_REQUEST = 'POST_MILESTONE_REQUEST';
export const POST_MILESTONE_SUCCESS = 'POST_MILESTONE_SUCCESS';
export const POST_MILESTONE_FAILURE = 'POST_MILESTONE_FAILURE';
export const PUT_MILESTONE_REQUEST = 'PUT_MILESTONE_REQUEST';
export const PUT_MILESTONE_SUCCESS = 'PUT_MILESTONE_SUCCESS';
export const PUT_MILESTONE_FAILURE = 'PUT_MILESTONE_FAILURE';
export const RESET_MILESTONE_RESET = 'RESET_MILESTONE_RESET';

export const GET_CODER_BY_ID_REQUEST = 'GET_CODER_BY_ID_REQUEST';
export const GET_CODER_BY_ID_SUCCESS = 'GET_CODER_BY_ID_SUCCESS';
export const GET_CODER_BY_ID_FAILURE = 'GET_CODER_BY_ID_FAILURE';

export const SET_CODER_FILTER = 'SET_CODER_FILTER';
export const RESET_CODER_FILTER = 'RESET_CODER_FILTER';

export const SET_JOB_TAB_INDEX = 'SET_JOB_TAB_INDEX';
export const RESET_JOB_TAB_INDEX = 'RESET_JOB_TAB_INDEX';
export const SET_CLIENT_JOB_TAB_INDEX = 'SET_CLIENT_JOB_TAB_INDEX';

// ==========client company registration type=================
export const CLIENT_REGISTRATION_COMPANY_REQUEST = ' CLIENT_REGISTRATION_COMPANY_REQUEST';
export const CLIENT_REGISTRATION_COMPANY_SUCCESS = 'CLIENT_REGISTRATION_COMPANY_SUCCESS';
export const CLIENT_REGISTRATION_COMPANY_FAILURE = 'CLIENT_REGISTRATION_COMPANY_FAILURE';
export const UPDATE_REGISTRATION_COMPANY_REQUEST = ' UPDATE_REGISTRATION_COMPANY_REQUEST';
export const RESET_REGISTRATION_COMPANY_STATUS = 'RESET_REGISTRATION_COMPANY_STATUS';

export const REGISTRATION_ADDRESS_REQUEST = 'REGISTRATION_ADDRESS_REQUEST';
export const REGISTRATION_ADDRESS_SUCCESS = 'REGISTRATION_ADDRESS_SUCCESS';
export const REGISTRATION_ADDRESS_FAILURE = 'REGISTRATION_ADDRESS_FAILURE';
export const UPDATE_REGISTRATION_ADDRESS_REQUEST = 'UPDATE_REGISTRATION_ADDRESS_REQUEST';
export const RESET_REGISTRATION_ADDRESS_STATUS = 'RESET_REGISTRATION_ADDRESS_STATUS';

export const REGISTRATION_DIGITAL_PRESENCE_REQUEST = 'REGISTRATION_DIGITAL_PRESENCE_REQUEST';
export const REGISTRATION_DIGITAL_PRESENCE_SUCCESS = 'REGISTRATION_DIGITAL_PRESENCE_SUCCESS';
export const REGISTRATION_DIGITAL_PRESENCE_FAILURE = 'REGISTRATION_DIGITAL_PRESENCE_FAILURE';
export const UPDATE_REGISTRATION_DIGITAL_PRESENCE_REQUEST =
  'UPDATE_REGISTRATION_DIGITAL_PRESENCE_REQUEST';
export const RESET_REGISTRATION_DIGITAL_PRESENCE_STATUS =
  'RESET_REGISTRATION_DIGITAL_PRESENCE_STATUS';

export const RESENT_VERIFY_EMAIL_REQUEST = 'RESENT_VERIFY_EMAIL_REQUEST';
export const RESENT_VERIFY_EMAIL_SUCCESS = 'RESENT_VERIFY_EMAIL_SUCCESS';
export const GET_PRIMARY_SKILLS = 'GET_PRIMARY_SKILLS';
export const GET_PRIMARY_SKILLS_SUCCESS = 'GET_PRIMARY_SKILLS_SUCCESS';
export const GET_PRIMARY_SKILLS_FAILURE = 'GET_PRIMARY_SKILLS_FAILURE';
export const SAVE_SKILL_REQUEST = 'SAVE_SKILL_REQUEST';
export const SAVE_SKILL_SUCCESS = 'SAVE_SKILL_SUCCESS';
export const SAVE_SKILL_FAILURE = 'SAVE_SKILL_FAILURE';
export const UPDATE_SKILL_REQUEST = 'UPDATE_SKILL_REQUEST';

export const SAVE_SKILL_EXPERIENCE_REQUEST = 'SAVE_SKILL_EXPERIENCE_REQUEST';
export const SAVE_SKILL_EXPERIENCE_SUCESS = 'SAVE_SKILL_EXPERIENCE_SUCESS';
export const SAVE_SKILL_EXPERIENCE_FAILURE = 'SAVE_SKILL_EXPERIENCE_FAILURE';
export const UPDATE_SKILL_EXPERIENCE_REQUEST = 'UPDATE_SKILL_EXPERIENCE_REQUEST';
export const RESET_SKILL_EXPERIENCE = 'RESET_SKILL_EXPERIENCE';

export const RESEND_VERIFY_EMAIL_REQUEST = 'RESEND_VERIFY_EMAIL_REQUEST';
export const RESEND_VERIFY_EMAIL_SUCCESS = 'RESEND_VERIFY_EMAIL_SUCCESS';
export const RESEND_VERIFY_EMAIL_FAILURE = 'RESEND_VERIFY_EMAIL_FAILURE';
export const RESET_RESEND_VERIFY_EMAIL_STATUS = 'RESET_RESEND_VERIFY_EMAIL_STATUS';

/** Coder Profile Fetch */

export const GET_CODER_ADDRESS = 'GET_CODER_ADDRESS';
export const GET_CODER_ADDRESS_SUCCESS = 'GET_CODER_ADDRESS_SUCCESS';
export const GET_CODER_ADDRESS_FAILURE = 'GET_CODER_ADDRESS_FAILURE';

export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS';
export const GET_COUNTRY_LIST_FAILURE = 'GET_COUNTRY_LIST_FAILURE';

export const GET_CODER_DIGITAL_PRESENCE = 'GET_CODER_DIGITAL_PRESENCE';
export const GET_CODER_DIGITAL_PRESENCE_SUCCESS = 'GET_CODER_DIGITAL_PRESENCE_SUCCESS';
export const GET_CODER_DIGITAL_PRESENCE_FAILURE = 'GET_CODER_DIGITAL_PRESENCE_FAILURE';

export const GET_ALL_RECOMMENDED_TECH = 'GET_ALL_RECOMMENDED_TECH';
export const GET_ALL_RECOMMENDED_TECH_SUCCESS = 'GET_ALL_RECOMMENDED_TECH_SUCCESS';
export const GET_ALL_RECOMMENDED_TECH_FAILURE = 'GET_ALL_RECOMMENDED_TECH_FAILURE';

export const SAVE_EDUCATION_QUALIFICATION = 'SAVE_EDUCATION_QUALIFICATION';
export const SAVE_EDUCATION_QUALIFICATION_SUCCESS = 'SAVE_EDUCATION_QUALIFICATION_SUCCESS';
export const SAVE_EDUCATION_QUALIFICATION_FAILURE = 'SAVE_EDUCATION_QUALIFICATION_FAILURE';
export const UPDATE_EDUCATION_QUALIFICATION = 'UPDATE_EDUCATION_QUALIFICATION';

export const SAVE_DEGREE = 'SAVE_DEGREE';
export const SAVE_DEGREE_SUCCESS = 'SAVE_DEGREE_SUCCESS';
export const SAVE_DEGREE_FAILURE = 'SAVE_DEGREE_FAILURE';
export const GET_DEGREE = 'GET_DEGREE';
export const GET_DEGREE_SUCCESS = 'GET_DEGREE_SUCCESS';
export const GET_DEGREE_FAILURE = 'GET_DEGREE_FAILURE';
export const UPDATE_DEGREE = 'UPDATE_DEGREE';
export const DELETE_DEGREE = 'DELETE_DEGREE';
export const DELETE_DEGREE_SUCCESS = 'DELETE_DEGREE_SUCCESS';
export const RESET_DEGREE_DATA = 'RESET_DEGREE_DATA';

export const SAVE_CERTIFICATE = 'SAVE_CERTIFICATE';
export const SAVE_CERTIFICATE_SUCCESS = 'SAVE_CERTIFICATE_SUCCESS';
export const SAVE_CERTIFICATE_FAILURE = 'SAVE_CERTIFICATE_FAILURE';
export const GET_CERTIFICATE = 'GET_CERTIFICATE';
export const GET_CERTIFICATE_SUCCESS = 'GET_CERTIFICATE_SUCCESS';
export const GET_CERTIFICATE_FAILURE = 'GET_CERTIFICATE_FAILURE';
export const UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE';
export const DELETE_CERTIFICATE = 'DELETE_CERTIFICATE';
export const DELETE_CERTIFICATE_SUCCESS = 'DELETE_CERTIFICATE_SUCCESS';
export const RESET_CERTIFICATE_DATA = 'RESET_CERTIFICATE_DATA';

export const RESET_EDUCATION_DEGREE_CERTIFICATE_STATUS =
  'RESET_EDUCATION_DEGREE_CERTIFICATE_STATUS';

export const GET_RECOMMENDED_CODER_REQUEST = 'GET_RECOMMENDED_CODER_REQUEST';
export const GET_RECOMMENDED_CODER_SUCCESS = 'GET_RECOMMENDED_CODER_SUCCESS';
export const GET_RECOMMENDED_CODER_FAILURE = 'GET_RECOMMENDED_CODER_FAILURE';
export const GET_CODER_SKILLS_AND_EXPERIENCE = 'GET_CODER_SKILLS_AND_EXPERIENCE';
export const GET_CODER_SKILLS_AND_EXPERIENCE_SUCCESS = 'GET_CODER_SKILLS_AND_EXPERIENCE_SUCCESS';
export const GET_CODER_SKILLS_AND_EXPERIENCE_FAILURE = 'GET_CODER_SKILLS_AND_EXPERIENCE_FAILURE';

export const GET_CODER_EDUCATIONAL_QUALIFICATION = 'GET_CODER_EDUCATIONAL_QUALIFICATION';
export const GET_CODER_EDUCATIONAL_QUALIFICATION_SUCCESS =
  'GET_CODER_EDUCATIONAL_QUALIFICATION_SUCCESS';
export const GET_CODER_EDUCATIONAL_QUALIFICATION_FAILURE =
  'GET_CODER_EDUCATIONAL_QUALIFICATION_FAILURE';
export const RESET_CODER_EDUCATIONAL_QUALIFICATION = 'RESET_CODER_EDUCATIONAL_QUALIFICATION';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const RESET_PASSWORD_UPDATE = 'RESET_PASSWORD_UPDATE';
export const SET_TECHNOLOGY_NAME = 'SET_TECHNOLOGY_NAME';
export const CLEAR_TECHNOLOGY_NAME = 'CLEAR_TECHNOLOGY_NAME';

export const GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS';
export const COMPANY_DETAILS_SUCCESS = 'COMPANY_DETAILS_SUCCESS';
export const COMPANY_DETAILS_FAILURES = 'COMPANY_DETAILS_FAILURE';

export const GET_CLIENT_PROFILE_DATA_BY_ID = 'GET_CLIENT_PROFILE_DATA_BY_ID';
export const GET_CLIENT_PROFILE_DATA = 'GET_CLIENT_PROFILE_DATA';
export const GET_CLIENT_PROFILE_DATA_SUCCESS = 'GET_CLIENT_PROFILE_DATA_SUCCESS';
export const GET_CLIENT_PROFILE_DATA_FAILURES = 'GET_CLIENT_PROFILE_DATA_FAILURE';

export const GET_ALL_RECOMMENDED_JOBS = 'GET_ALL_RECOMMENDED_JOBS';

export const GET_ALL_RECOMMENDED_JOB_SUCCESS = 'GET_ALL_RECOMMENDED_JOB_SUCCESS';
export const GET_ALL_RECOMMENDED_JOB_FAILURE = 'GET_ALL_RECOMMENDED_JOB_FAILURE';
export const GET_ADMIN_DATA_REQUEST = 'GET_ADMIN_DATA_REQUEST';
export const GET_ADMIN_DATA_SUCCESS = 'GET_ADMIN_DATA_SUCCESS';
export const GET_ADMIN_DATA_FAILURE = 'GET_ADMIN_DATA_FAILURE';
export const GET_ADMIN_DATA_RESET = 'GET_ADMIN_DATA_RESET';

export const INIT_ADMIN_CLIENT = 'INIT_ADMIN_CLIENT';
export const GET_ADMIN_CLIENT_REQUEST = 'GET_ADMIN_CLIENT_REQUEST';
export const GET_ADMIN_CLIENT_SUCCESS = 'GET_ADMIN_CLIENT_SUCCESS';
export const GET_ADMIN_CLIENT_FAILURE = 'GET_ADMIN_CLIENT_FAILURE';
export const RESET_ADMIN_CLIENT = 'RESET_ADMIN_CLIENT';
export const PATCH_ADMIN_CLIENT_REQUEST = 'PATCH_ADMIN_CLIENT_REQUEST';
export const PATCH_ADMIN_CLIENT_RESET = 'PATCH_ADMIN_CLIENT_RESET';
export const PATCH_ADMIN_CLIENT_SUCCESS = 'PATCH_ADMIN_CLIENT_SUCCESS';
export const PATCH_ADMIN_CLIENT_FAILURE = 'PATCH_ADMIN_CLIENT_FAILURE';

export const INIT_ADMIN_DETAIL = 'INIT_ADMIN_DETAIL';
export const INIT_ADMIN_CODER = 'INIT_ADMIN_CODER';
export const INIT_ADMIN_STATUS_REQUEST = 'INIT_ADMIN_STATUS_REQUEST';
export const RESET_CURRENT_ADMIN_CODER = 'RESET_CURRENT_ADMIN_CODER';
export const SET_CURRENT_ADMIN_CODER = 'SET_CURRENT_ADMIN_CODER';
export const GET_ADMIN_CODER_REQUEST = 'GET_ADMIN_CODER_REQUEST';
export const GET_ADMIN_CODER_SUCCESS = 'GET_ADMIN_CODER_SUCCESS';
export const GET_ADMIN_CODER_FAILURE = 'GET_ADMIN_CODER_FAILURE';
export const PATCH_ADMIN_CODER_REQUEST = 'PATCH_ADMIN_CODER_REQUEST';
export const PATCH_ADMIN_CODER_RESET = 'PATCH_ADMIN_CODER_RESET';
export const PATCH_ADMIN_CODER_SUCCESS = 'PATCH_ADMIN_CODER_SUCCESS';
export const PATCH_ADMIN_CODER_FAILURE = 'PATCH_ADMIN_CODER_FAILURE';
export const RESET_ADMIN_CODER = 'RESET_ADMIN_CODER';

export const GET_TnC = 'GET_TnC';
export const GET_TnC_SUCCESS = 'GET_TnC_SUCCESS';
export const GET_TnC_FAIURES = 'GET_TnC_FAIURES';
export const GET_TnC_REQUEST = 'GET_TnC_REQUEST';

export const GET_USER_INFO_REQUEST = 'GET_USER_INFO_REQUEST';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAILURE = 'GET_USER_INFO_FAILURE';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';

export const RESET_ADMIN_JOB_REQUEST = 'RESET_ADMIN_JOB_REQUEST';
export const GET_ADMIN_JOB_REQUEST = 'GET_ADMIN_JOB_REQUEST';
export const GET_ADMIN_JOB_FOR_CLIENT_REQUEST = 'GET_ADMIN_JOB_FOR_CLIENT_REQUEST';
export const GET_ADMIN_JOB_SUCCESS = 'GET_ADMIN_JOB_SUCCESS';
export const GET_ADMIN_JOB_FAILURE = 'GET_ADMIN_JOB_FAILURE';

export const RESET_ADMIN_PROPOSAL_JOB_REQUEST = 'RESET_ADMIN_PROPOSAL_JOB_REQUEST';
export const GET_ADMIN_PROPOSAL_JOB_REQUEST = 'GET_ADMIN_PROPOSAL_JOB_REQUEST';
export const GET_ADMIN_PROPOSAL_BY_JOB_ID_REQUEST = 'GET_ADMIN_PROPOSAL_BY_JOB_ID_REQUEST';
export const GET_ADMIN_PROPOSAL_JOB_SUCCESS = 'GET_ADMIN_PROPOSAL_JOB_SUCCESS';
export const GET_ADMIN_PROPOSAL_JOB_FAILURE = 'GET_ADMIN_PROPOSAL_JOB_FAILURE';

export const GET_CODER_DETAILS_REQUEST = 'GET_CODER_DETAILS_REQUEST';
export const GET_CODER_DETAILS_SUCCESS = 'GET_CODER_DETAILS_SUCCESS';
export const GET_CODER_DETAILS_FAILURE = 'GET_CODER_DETAILS_FAILURE';
/**
 * Technology Fetch
 */
export const GET_ALL_TECHNOLOGIES = 'GET_ALL_TECHNOLOGIES';
export const GET_ALL_TECHNOLOGIES_SUCCESS = 'GET_ALL_TECHNOLOGIES_SUCCESS';
export const GET_ALL_TECHNOLOGIES_FAILURE = 'GET_ALL_TECHNOLOGIES_FAILURE';

/**
 * Fetch Coders
 */
export const GET_CODERS_LIST = 'GET_CODERS_LIST';
export const GET_CODERS_LIST_SUCCESS = 'GET_CODERS_LIST_SUCCESS';
export const GET_CODERS_LIST_FAILURE = 'GET_CODERS_LIST_FAILURE';
export const CLEAR_CODERS_LIST = 'CLEAR_CODERS_LIST';

/**
 * Invite Coders
 */
export const GET_ALL_INVITES = 'GET_ALL_INVITES';
export const GET_ALL_INVITES_SUCCESS = 'GET_ALL_INVITES_SUCCESS';
export const GET_ALL_INVITES_FAILURE = 'GET_ALL_INVITES_FAILURE';
export const SEND_INVITE = 'SEND_INVITE';
export const SEND_INVITE_SUCCESS = 'SEND_INVITE_SUCCESS';
export const SEND_INVITE_FAILURE = 'SEND_INVITE_FAILURE';
export const CLEAR_INVITE_ERROR = 'CLEAR_INVITE_ERROR';
export const CLEAR_JOB_INVITATIONS = 'CLEAR_JOB_INVITATIONS';
export const SEND_INVITE_CODER_PROFILE_STATUS = 'SEND_INVITE_CODER_PROFILE_STATUS';
export const SEND_INVITE_CODER_STATUS = 'SEND_INVITE_CODER_STATUS';

/**
 * Latest Jobs
 */

export const CLEAR_LATEST_JOB_REQUEST = 'CLEAR_LATEST_JOB_REQUEST';
export const GET_LATEST_JOB_REQUEST = 'GET_LATEST_JOB_REQUEST';
export const GET_LATEST_JOB_SUCCESS = 'GET_LATEST_JOB_SUCCESS';
export const GET_LATEST_JOB_FAILURE = 'GET_LATEST_JOB_FAILURE';
// ------------------

export const PATCH_PAYMENT_FIXED_REQUEST = 'PATCH_PAYMENT_FIXED_REQUEST';
export const PATCH_PAYMENT_FIXED_SUCCESS = 'PATCH_FIXED_SUCCESS';
export const PATCH_PAYMENT_FIXED_FAILURE = 'PATCH_FIXED_FAILURE';
export const PATCH_PAYMENT_TIMESHEET_REQUEST = 'PATCH_PAYMENT_TIMESHEET_REQUEST';
export const PATCH_PAYMENT_TIMESHEET_SUCCESS = 'PATCH_PAYMENT_TIMESHEET_SUCCESS';
export const PATCH_PAYMENT_TIMESHEET_FAILURE = 'PATCH_PAYMENT_TIMESHEET_FAILURE';
export const CLEAR_RECOMMENDED_JOBS = 'CLEAR_RECOMMENDED_JOBS';

export const GET_PROPOSAL_RECEIVED_REQUEST = 'GET_PROPOSAL_RECEIVED_REQUEST';
export const GET_PROPOSAL_RECEIVED_SUCCESS = 'GET_PROPOSAL_RECEIVED_SUCCESS';
export const GET_PROPOSAL_RECEIVED_FAILURE = 'GET_PROPOSAL_RECEIVED_FAILURE';

export const GET_CLIENT_INVITE_JOB_REQUEST = 'GET_CLIENT_INVITE_JOB_REQUEST';
export const GET_CLIENT_INVITE_JOB_SUCCESS = 'GET_CLIENT_INVITE_JOB_SUCCESS';
export const GET_CLIENT_INVITE_JOB_FAILURE = 'GET_CLIENT_INVITE_JOB_FAILURE';

export const GET_ALL_RECOMMENDED_HOME_JOBS_REQUEST = 'GET_ALL_RECOMMENDED_HOME_JOBS_REQUEST';
export const GET_ALL_RECOMMENDED_HOME_JOB_SUCCESS = 'GET_ALL_RECOMMENDED_HOME_JOB_SUCCESS';
export const GET_ALL_RECOMMENDED_HOME_JOB_FAILURE = 'GET_ALL_RECOMMENDED_HOME_JOB_FAILURE';

export const POST_CONTACT_SUPPORT_REQUEST = 'POST_CONTACT_SUPPORT_REQUEST';
export const POST_DISPUTE_REQUEST = 'POST_DISPUTE_REQUEST';
export const POST_CONTACT_SUPPORT_SUCCESS = 'POST_CONTACT_SUPPORT_SUCCESS';
export const POST_CONTACT_SUPPORT_FAILURE = 'POST_CONTACT_SUPPORT_FAILURE';
export const RESET_CONTACT_SUPPORT = 'RESET_CONTACT_SUPPORT';

/*
 * Selected client/coder id
 */

export const GET_CHAT_WITH = 'GET_CHAT_WITH';
export const SAVE_CHAT_WITH = 'SAVE_CHAT_WITH';
export const RESET_CHAT_WITH = 'RESET_CHAT_WITH';

// strip payment
export const PAYMENT_ONBOARD_SET = 'PAYMENT_ONBOARD_SET';
export const PAYMENT_ONBOARD_RESET = 'PAYMENT_ONBOARD_RESET';

export const CREATE_STRIPE_ACCOUNT_REQUEST = 'CREATE_STRIPE_ACCOUNT_REQUEST';
export const CREATE_STRIPE_ACCOUNT_SUCCESS = 'CREATE_STRIPE_ACCOUNT_SUCCESS';
export const CREATE_STRIPE_ACCOUNT_FAILURE = 'CREATE_STRIPE_ACCOUNT_FAILURE';

export const STRIPE_FEE_REQUEST = 'STRIPE_FEE_REQUEST';
export const STRIPE_FEE_SUCCESS = 'STRIPE_FEE_SUCCESS';
export const STRIPE_FEE_FAILURE = 'STRIPE_FEE_FAILURE';
export const RESET_STRIPE_FEE = 'RESET_STRIPE_FEE';

export const GET_STATE_REQUEST = 'GET_STATE_REQUEST';
export const GET_STATE_SUCCESS = 'GET_STATE_SUCCESS';
export const GET_STATE_ERROR = 'GET_STATE_ERROR';

export const STRIPE_PAYMENT_CHECKOUT_REQUEST = 'STRIPE_PAYMENT_CHECKOUT_REQUEST';
export const STRIPE_PAYMENT_CHECKOUT_SUCCESS = 'STRIPE_PAYMENT_CHECKOUT_SUCCESS';
export const STRIPE_PAYMENT_CHECKOUT_FAILURE = 'STRIPE_PAYMENT_CHECKOUT_FAILURE';
export const STRIPE_PAYMENT_CHECKOUT_RESET = 'STRIPE_PAYMENT_CHECKOUT_RESET';

export const GET_RECENT_MESSAGE_REQUEST = 'GET_RECENT_MESSAGE_REQUEST';
export const GET_RECENT_MESSAGE_SUCCESS = 'GET_RECENT_MESSAGE_SUCCESS';
export const GET_RECENT_MESSAGE_ERROR = 'GET_RECENT_MESSAGE_ERROR';

export const SAVE_BANK_DETAILS_REQUEST = 'SAVE_BANK_DETAILS_REQUEST';
export const UPDATE_BANK_DETAILS_REQUEST = 'UPDATE_BANK_DETAILS_REQUEST';
export const SAVE_BANK_DETAILS_SUCESSS = 'SAVE_BANK_DETAILS_SUCESSS';
export const SAVE_BANK_DETAILS_FAILURE = 'SAVE_BANK_DETAILS_FAILURE';
export const RESET_PAYMENT_PAGE_STATE = 'RESET_PAYMENT_PAGE_STATE';

export const GET_BANK_DETAILS = 'GET_BANK_DETAILS';
export const GET_BANK_DETAILS_SUCCESS = 'GET_BANK_DETAILS_SUCCESS';
export const GET_BANK_DETAILS_FAILURE = 'GET_BANK_DETAILS_FAILURE';

export const GET_ADMIN_DISPUTES = 'GET_ADMIN_DISPUTES';
export const GET_ADMIN_DISPUTES_SUCCESS = 'GET_ADMIN_DISPUTES_SUCCESS';
export const GET_ADMIN_DISPUTES_FAILURE = 'GET_ADMIN_DISPUTES_FAILURE';

export const SET_ISEDITE_MILESTONE = 'SET_ISEDITE_MILESTONE';

export const GET_NOTIFICATION_REQUEST = 'GET_NOTIFICATION_REQUEST';
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';
export const GET_NOTIFICATION_FAILURE = 'GET_NOTIFICATION_FAILURE';

export const UPDATE_NOTIFICATION_REQUEST = 'UPDATE_NOTIFICATION_REQUEST';
export const UPDATE_NOTIFICATION_FAILURE = 'UPDATE_NOTIFICATION_FAILURE';

/*==============Report=====================*/

export const GET_CLIENT_CODER_REQUEST = 'GET_CLIENT_CODER_REQUEST';
export const GET_CLIENT_CODER_SUCCESS = 'GET_CLIENT_CODER_SUCCESS';
export const GET_CLIENT_CODER_FAILURE = 'GET_CLIENT_CODER_FAILURE';

export const GET_TRANSACTION_REPORT_REQUEST = 'GET_TRANSACTION_REPORT_REQUEST';
export const GET_TRANSACTION_REPORT_SUCCESS = 'GET_TRANSACTION_REPORT_SUCCESS';
export const GET_TRANSACTION_REPORT_FAILURE = 'GET_TRANSACTION_REPORT_FAILURE';
